import type { IconSvgObject } from './types';

const ArchiveOff03Icon: IconSvgObject = [
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 9V16M4 9V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 4H21C21.5523 4 22 4.44772 22 5V8C22 8.55228 21.5523 9 21 9H13M4 4H3C2.44772 4 2 4.44772 2 5V8C2 8.55228 2.44772 9 3 9H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArchiveOff03Icon;
